<template>
<div class="card" v-loading.fullscreen.lock="loader">
  <div class="section-heading" align="center">CREATE MULTIPLE USERS</div>
  <br>
  <br>
  <br>
  <br>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="top">
    <el-row>
      <el-col :span="11">
        <el-form-item label="Select Campus" prop="role">
          <el-select v-model="form.role" placeholder="Select Campus">
            <el-option
              v-for="(item, key) in surveyRolesList"
              :key="key"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="CSV File" prop="userFile">
          <div style="position: absolute; right: 0px; top: -40px; color: #0c3294;"><a href="https://firebasestorage.googleapis.com/v0/b/campus-recruitment-test.appspot.com/o/cr_users%2Ftest1-Aug-2018_USers1533624856331.csv?alt=media&token=02cb72c3-92e5-4896-9c97-dfbb3db46a8c" style="color: #0c3294;"><i style="color: #0c3294;" class="el-icon-download"></i>Sample CSV</a></div>
          <input id="CSVFileId" style="background-color: white; padding: 10px; width: 100%; border: 1px solid #c0c4cc;" @change="onFileChange" type="file" accept=".csv" />
        </el-form-item>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col>
        <el-form-item label="Enter Emails" prop="emails" >
          <el-input placeholder="abc@gmail.com,pqr@yahoo.com,etc..." v-model="form.emails" multiple>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <br>
  <div align="right">
    <el-button class="btn-theme" @click="UploadUser('form')">Upload Users</el-button>
  </div>
  <el-dialog
    class="SubGroup-heading"
    title="New Campus"
    :visible.sync="dialogRole"
    align="middle"
    width="60%">
    <el-form ref="form2" :model="form2" :rules="rules2" label-width="150px" label-position="left">
      <el-form-item class="col-md-12" label="Campus Name" prop="roleName">
        <el-input v-model="form2.roleName" placeholder="Enter Campus Name"></el-input>
      </el-form-item>
      <div class="row m-3 flex-end" style="margin-left:6rem;">
        <el-button class="btn-theme" @click="addRole('form2')">Add Campus</el-button>
      </div>
    </el-form>
  </el-dialog>
</div>
</template>
<script>
import firebase from 'firebase'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UploadUser',
  data () {
    var validateEmails = (rule, value, callback) => {
      console.log('=====Value', value)
      if (value) {
        var arr = value.split(', ')
        arr.forEach(ele => {
          var atpos = ele.indexOf('@')
          var dotpos = ele.lastIndexOf('.')
          if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= ele.length) {
            callback(new Error('Please input correct email id'))
          }
        })
        callback()
      } else {
        callback(new Error('Enter Email Id'))
      }
    }
    return {
      surveyRolesList: ['Add New Campus'],
      SelectedCSVFile: '',
      dialogRole: false,
      loader: false,
      CSVFile: '',
      fileinput: '',
      index: 9,
      URL: '',
      updatedURL: '',
      form: {
        role: '',
        userFile: '',
        emails: ''
      },
      form2: {
        roleName: ''
      },
      rules: {
        role: [
          { required: true, message: 'Select Campus Name', trigger: 'change' }
        ],
        userFile: [
          { required: true, message: 'Select CSV File', trigger: 'change' }
        ],
        emails: [
          { validator: validateEmails, trigger: 'change' }
        ]
      },
      rules2: {
        roleName: [
          { required: true, message: 'Enter Role Name', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSurveyRoles: 'Survey/getSurveyRoles',
      getRole: 'Survey/getRole',
      getBulkUser: 'Survey/getBulkUser'
    })
  },
  methods: {
    ...mapActions({
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      createRole: 'Survey/createRole',
      addBulkUser: 'Survey/addBulkUser'
    }),
    onFileChange (e) {
      console.log('FILESELETED', e)
      this.form.userFile = e
    },
    UploadUser (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('FILE', this.form.userFile)
          this.loader = true
          var that = this
          var date = new Date().getTime()
          var storageRef = firebase.storage().ref()
          var uploadTask = storageRef.child(`cr_users/${this.form.role}_USers${date}.csv`).put(this.form.userFile.target.files[0])
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            function (snapshot) {
              console.log(snapshot)
            },
            function (error) {
              console.log('ERROR===', error)
              this.$message.error('please try again')
              this.loader = false
            },
            function () {
              uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                console.log('File available at', downloadURL)
                that.URL = downloadURL
              })
            })
        }
      })
    },
    addRole (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.createRole({
            role: this.form2.roleName
          })
          this.dialogRole = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    uploadFile () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var EmaiArr = this.form.emails.split(', ')
          this.addBulkUser({
            csv_url: this.updatedURL,
            roles: this.form.role,
            emails: EmaiArr
          })
          // this.loader = false
          // this.$refs['form'].resetFields()
        }
      })
    }
  },
  watch: {
    'form.userFile' (value) {
      console.log('FILE Value', value)
    },
    URL (value) {
      console.log('VALUE URL============', value)
      var urlString = value
      this.updatedURL = String(urlString)
      console.log('UPdated URL=========', this.updatedURL)
      this.uploadFile()
    },
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyRolesList = ['Add New Campus']
        console.log('ctreateee', value)
        var arr = Object.keys(value.data)
        console.log('arrrrr', arr)
        arr.forEach(ele => {
          this.surveyRolesList.push(ele)
        })
        console.log('Survey', this.surveyRolesList)
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    'form.role' (value) {
      console.log('VALUE', value)
      if (value === 'Add New Campus') {
        this.form.role = ''
        this.dialogRole = true
      }
    },
    getRole (value) {
      if (value === 'Error') {
        this.$message.error('Try Again')
        this.loader = false
      } else if (value.success === true) {
        this.$refs['form2'].resetFields()
        this.fetchSurveyRoles()
        console.log('New Added Campus', value)
        this.form.role = value.data.role
      } else {
        this.$message.error(value.message)
        this.loader = false
      }
    },
    getBulkUser (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        document.getElementById('CSVFileId').value = ''
        this.$refs['form'].resetFields()
        this.$message.success('User created successfully')
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    }
  },
  mounted () {
    this.fetchSurveyRoles()
    this.loader = true
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/UploadUserData.vue